export default __webpack_public_path__ + "static/13-f94e95b5fb00496d8825ee913c899d79.jpg";